<template>
  <!--
    プレオプトインダイアログV2 のプレビュー
    SDK: pushone-javascript-sdk/browserpush/src/frontend/template/components/dialog/preOptinV2.ts
    SDK SCSS: resources/sass/plugin/_preoptin-dialog-v2.scss (SDK SCSS のコピー)
    ※SDK 更新時はテンプレートを上書きし、SDK SCSS も上記 SCSS に反映してください。
    -->
  <div
    class="pushone-preoptin-dialog-v2"
    role="dialog"
    aria-label="プッシュ通知のご案内"
    aria-live="polite"
    :style="cssVariables"
  >
    <div v-if="dialogValues.imageUrl" class="pushone-preoptin-dialog-v2__image">
      <img :src="dialogValues.imageUrl" alt="" />
    </div>
    <div class="pushone-preoptin-dialog-v2__inner">
      <div v-if="dialogValues.iconUrl" class="pushone-preoptin-dialog-v2__icon">
        <img :src="dialogValues.iconUrl" alt="" />
      </div>
      <div class="pushone-preoptin-dialog-v2__body">
        <p v-if="dialogValues.title" class="pushone-preoptin-dialog-v2__title">{{ dialogValues.title }}</p>
        <p v-if="dialogValues.description" class="pushone-preoptin-dialog-v2__description">{{ dialogValues.description }}</p>
        <div class="pushone-preoptin-dialog-v2__buttons">
          <button type="button" class="pushone-preoptin-dialog-v2__button--deny" @click="$emit('close')">{{ dialogValues.denyLabel || SDK_DEFAULTS.denyLabel }}</button>
          <button type="button" class="pushone-preoptin-dialog-v2__button--allow" @click="$emit('close')">{{ dialogValues.allowLabel || SDK_DEFAULTS.allowLabel }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// SDK 側の実装デフォルト
// SDK: pushone-javascript-sdk/browserpush/src/modules/dialog/preOptinDialogV2Module.ts
const SDK_DEFAULTS = {
  denyLabel: '今はしない',
  allowLabel: '受け取る',
};

export default {
  props: {
    dialogValues: {
      type: Object,
      required: true,
    },
  },
  emits: ["close"],
  data() {
    return {
      SDK_DEFAULTS,
    };
  },
  computed: {
    cssVariables() {
      const style = this.dialogValues.style;
      if (!style || typeof style !== 'object') {
        return {};
      }
      const vars = {};
      for (const [key, value] of Object.entries(style)) {
        if (value === undefined || value === null || value === '') {
          continue;
        }
        const cssKey = key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
        vars[`--pushone-preoptin-dialog-v2-${cssKey}`] = String(value);
      }
      return vars;
    },
  },
};
</script>

<style scoped>
/* CMSプレビュー用: スタイル設定ダイアログ(z-index: 10000)より上に表示 */
.pushone-preoptin-dialog-v2 {
  z-index: 10001 !important;
}
</style>
